import { type FC } from 'react';
import {
  DeviceMobile
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconDeviceMobileProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconDeviceMobile: FC<UiIconDeviceMobileProps> = (props) => {
  return (
    <UiIcon
      IconComponent={DeviceMobile}
      {...props}
    />
  );
};
